var Application;

Application = {
    ready: function () {

        Application.City.ready();
        Application.Company.ready();
        Application.Customize.ready();
        Application.Project.ready();
        Application.Bubbles.ready();
        Application.Improvements.ready();
        Application.Summary.ready();
        Application.BackgroundSwitch.ready();

    }
};

// Initiate the application
jQuery(function () {
    Application.ready();
});